<template>
    <div>
        <div class="phone-container input">
            <img class="icon" src="@img/phone.png" />
            <input
                class="phone-input ios-no-zoom"
                placeholder="手机号"
                type="tel"
                inputmode="numeric"
                autocomplete="tel"
                maxlength="11"
                v-model="localPhone"
                @blur="onBlur"
            />
        </div>
        <div class="code-container input">
            <img class="icon" src="@img/code.png" />
            <input
                class="code-input ios-no-zoom"
                placeholder="验证码"
                type="tel"
                inputmode="numeric"
                autocomplete="one-time-code"
                maxlength="6"
                v-model="localCode"
                @blur="onBlur"
            />
            <van-button :class="'verify ' + (verifyDisable ? 'loading' : '')" type="primary" :disabled="verifyDisable"
                @click="onVerify">{{ verifyText }}</van-button>

        </div>
        <van-button class="login" :loading="loading" type="primary" @click="onLogin">登录</van-button>
    </div>

</template>

<script>
import { resetViewportScroll } from '@/utils/viewport'

export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        verifyText: {
            type: String,
            default: '获取验证码',
        },
        verifyDisable: {
            type: Boolean,
            default: false,
        },
        phone: String,
        code: String,
    },
    watch: {
        localPhone(newVal) {
            this.$emit('update:phone', newVal);
        },
        localCode(newVal) {
            this.$emit('update:code', newVal);
        }
    },
    data() {
        return {
            localPhone: this.phone,
            localCode: this.code
        }
    },
    methods: {
        onVerify() {
            this.$emit('verify');
        },
        onLogin() {
            this.$emit('login');
        },
        onBlur() {
            resetViewportScroll();
        },
    },
};
</script>

<style scoped lang="scss">
.phone-container {
    margin: 51px 40px 20px;
    background-color: #fff;
}

.code-container {
    margin: 20px 40px;
    background-color: #fff;
}

.phone-container .icon {
    margin-left: 11px;
    width: 12px;
    height: 18px;
    display: block;
}

.code-container .icon {
    margin-left: 7px;
    width: 20px;
    height: 20px;
    display: block;
}

input {
    border: 0px;
    font-size: 14px;
    color: #333;
}
input.ios-no-zoom,
input.ios-no-zoom::placeholder {
    font-size: 16px;
}
input:focus {
    outline: none;
    border: 0px;
}

input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.phone-input {
    height: 17px;
    width: 225px;
    margin-left: 13px;
}

.code-input {
    height: 22px;
    width: 110px;
    margin-left: 7px;
}

.verify {
    background-color: #596afd !important;
    width: 118px !important;
    height: 100%;
    border-radius: 0;
    margin-right: 0 !important;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    padding: 0;
    border: 0;
    color: #fff;
}

.loading {
    background-color: lightgray !important;
    color: white !important;
}

.login {
    background-color: #596afd !important;
    height: 54px;
    width: 295px !important;
    margin: 0 auto;
    margin-top: 140px;
    border-radius: 6px !important;
    border: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 400;
    color: #fff;
}

.input {
    display: flex;
    align-items: center;
    border: 1px solid #e7e4e9;
    border-radius: 6px;
    height: 44px;
    overflow: hidden;
}
</style>
